import styled from 'styled-components'

const StyledPaymentHistory = styled.div`
  .billing-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: ${({ theme }) => theme.fonts.lexend};
    margin-top: 20px;

    .billing-subheader {
      color: ${({ theme }) => theme.colors.gray[700]};
      font-size: 20px;
      line-height: 32px;
      font-weight: 400;
    }
  }

  .payment-history {
    .payment-history-table {
      margin: 10px 0 45px 0;

      th {
        color: ${({ theme }) => theme.colors.gray[300]};
      }

      th,
      td,
      td > a {
        font-family: ${({ theme }) => theme.fonts.nunito};
        font-weight: 400;
      }

      a:hover {
        color: ${({ theme }) => theme.colors.green[300]};
        text-decoration: none;
      }
    }

    .load-more-div {
      display: flex;
      justify-content: center;

      .billing-button {
        color: ${({ theme }) => theme.colors.green[300]};
        font-family: ${({ theme }) => theme.fonts.lexend};
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 1px;
        border: 0;
        background: transparent;
        text-transform: uppercase;
      }
    }
  }
`

export default StyledPaymentHistory
